/**
 * Created by Vladislav on 19.02.2026.
 */

const NewHeroAction = function (f) {
    const heroColor = this.game.outcome === GameBase.OUTCOME_VICTORY && typeof match3 !== "undefined" && match3.heroes.readyToOpen();
    if (heroColor) {
        const actions = [];

        actions.push((f) => {
            match3.heroes.incLevel(heroColor);

            new HeroWindow({
                color: heroColor,
                type: "unlocked"
            });
            cleverapps.focusManager.onceNoWindowsListener = f;
        });

        const heroComics = match3.heroes.getComics(heroColor);
        if (heroComics) {
            actions.push((f) => {
                ComicsScene.showComics(f, heroComics);
            });

            actions.push((f) => {
                cleverapps.meta.gotoMainLocation(f);
            });
        }

        cleverapps.focusManager.compound(f, actions);
    } else {
        f();
    }
};